import styled from "styled-components";

export const TagContainer = styled.div`
  background: ${({ theme, newTag }) =>
    newTag ? theme.primary : theme.backgroundTag};
  border-radius: ${props => props.theme.br.pill};
  margin: ${props => (!props.margin ? "5px" : props.margin)};
  padding: 0px ${({ theme }) => theme.spacing[3]};
  color: ${props => props.theme.textLight};
  display: inline-flex;
  justify-content: ${props => (props.ellipsis ? "center" : "center")};
  cursor: pointer;
  height: ${({ theme, size }) =>
    size === "sm"
      ? theme.filters.height.sm
      : size === "md"
      ? theme.filters.height.md
      : size === "lg"
      ? theme.filters.height.lg
      : theme.filters.height.default};
  position: relative;
  transition: width 3s ease-in;
  width: auto;
  .text {
    font-family: ${({ theme, fontStyle }) =>
      fontStyle === "medium" ? theme.p3m.ff : theme.p3b.ff};
    white-space: nowrap;
    text-align: center !important;
    display: flex;
    align-items: center;

    ${props =>
      props.ellipsis &&
      ` text-overflow: ellipsis;
        max-width: 85px;
        overflow: hidden;
      `}
  }
`;
